import ExecutePopupHeaderImage from './ExecutePopupHeaderImage';

export default ExecutePopupHeaderImage;
